import React from 'react';
import _ from 'lodash';
import PaymentPlansList from '../common/payment_plans/List';
import SelectQuestion from '../common/questions/Select';
import RadioQuestion from '../common/questions/Radio';
import TextQuestion from '../common/questions/Text';
import CheckQuestion from '../common/questions/Check';
import CheckListQuestion from '../common/questions/CheckList';
import CheckoutActionsPopup from '../common/CheckoutActionsPopup';
import RegistrationPlayerSelection from '../common/RegistrationPlayerSelection';
import PersonSelection from './modals/PersonSelection';
import { generateRandomId } from '../../../helpers';
import CartPopup from '../common/CartPopup';
import config from '../../../config';
import request from 'superagent';
import Season from './partials/Season';
import Person from './partials/Person';
import Team from './partials/Team';
import Division from './partials/Division';


//const Soon = () => {
class PendingRegistration extends React.Component {

    state = {
        questions: null,
        paymentPlans: null,
        divisions: null,
        selectedDivision: null,
        selectedPlan: null,
        selectedTeam: null,
        selectedUser: null,
        selectedRole: null,
        selectedSeason: null,
        selectedLeague: null,
        bootstrapped: false,
        step: 1,
        isCheckoutActionsOpen: false,
        isPlayerSelectionOpen: false,
        mode: null,
        fetchingDataLocally: false
    }

    // Lifecycle
    componentWillMount() {
        const { setTitle, pouch, league } = this.props;

        setTitle && setTitle({
            main: 'Registration',
            sub: (pouch && pouch.selectedLeague) ? pouch.selectedLeague.LeagueName : null
        });

        this.setState(_.extend(this.state, this.props.pouch))
        this.props.divisionsActions && this.props.divisionsActions.clearDivisions();

        // TODO: fetch divisions and stuffs
        /*if (pouch && pouch.selectedSeason) {
            this.props.divisionsActions &&
                this.props.divisionsActions.fetchForRegistrationOfUsers(pouch.selectedSeason.IdSeason, pouch.selectedUser.IdUser, pouch.mode === 1 ? 3 : 4)
        }*/

        // After fetching Payment plans and Questions
        const exit = _.after(2, () => {
            this.setState({
                fetchingDataLocally: false,
                selectedDivision: pouch.selectedDivision,
                selectedTeam: pouch.selectedTeam,
                bootstrapped: true
            }, this.next);
        });

        // Spinner
        this.setState({ fetchingDataLocally: true });

        // Get payment plans        
        request.get(`${config.apiEndpoint}/api/v4/paymentPlans/${pouch.selectedDivision.IdDivision}/3`)
            .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
            .then((data) => {
                this.setState({ paymentPlans: data.body.plans });
            }, () => {
                this.setState({ paymentPlans: null });
            }).finally(exit);

        // Get questions        
        request.get(`${config.apiEndpoint}/api/v4/registration/questions/${pouch.selectedDivision.IdDivision}/3`)
            .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
            .then((data) => {
                this.setState({ questions: data.body.questions });
            }, () => {
                this.setState({ questions: null });
            }).finally(exit);

        if ((!league || !league.IdLeague) && pouch && pouch.selectedLeague) {
            this.props.leagueActions &&
                this.props.leagueActions.fetchLeague(pouch.selectedLeague.IdLeague)
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState(_.extend(nextProps.pouch, {
            divisions: nextProps.divisions,
            bootstrapped: true
        }));
    }
    //

    back = () => {
        const { step } = this.state;
        if (step === 2) {
            this.props.router && this.props.router.goBack();
        } else {
            this.props.divisionsActions && this.props.divisionsActions.clearQuestions();
            this.setState({ step: 2 });
        }
    }

    next = () => {
        const { step } = this.state;
        if (step === 1) {
            this.setState({
                step: (this.state.paymentPlans && this.state.paymentPlans.length) ? 2 : (this.state.questions && this.state.questions.length ? 3 : 1)
            }, function () {
                // still 1 ? then add to cart and continue
                if (this.state.step === 1) {
                    this.addToCart(); //?
                    this.setState({
                        isCheckoutActionsOpen: true
                    });
                }
            });
        } else if (step === 2) {
            if (this.state.questions && this.state.questions.length) {
                this.setState({
                    step: 3
                }); // TODO: if there are questions
            } else {
                this.addToCart();
                this.setState({
                    isCheckoutActionsOpen: true
                });
            }
        }
    }

    backToDivisions = () => {
        const { divisions } = this.state;
        divisions.Male && divisions.Male.forEach((d) => {
            d.selected = false;
        });
        divisions.Female && divisions.Female.forEach((d) => {
            d.selected = false;
        });
        divisions.Coed && divisions.Coed.forEach((d) => {
            d.selected = false;
        });
        this.setState({
            selectedDivision: null,
            questions: null,
            paymentPlans: null,
            step: 1,
            divisions
        });
    }

    selectPaymentPlan = (pp) => {
        const { paymentPlans } = this.state;
        paymentPlans.forEach((plan) => {
            plan.selected = (plan.IdPlan === pp.IdPlan && plan.Name === pp.Name);
        });
        this.setState({
            selectedPlan: pp,
            paymentPlans
        });
    }

    toggleCheckoutActions = () => {
        this.setState({
            isCheckoutActionsOpen: !this.state.isCheckoutActionsOpen
        });
    }

    tooglePlayerSelection = () => {
        this.setState({
            isPlayerSelectionOpen: !this.state.isPlayerSelectionOpen,
            isCheckoutActionsOpen: false
        });
    }

    cancelRegisterAnother = () => {
        this.setState({
            isPlayerSelectionOpen: false,
            isCheckoutActionsOpen: true
        });
    }

    restart = (newPouch) => {

        this.props.divisionsActions && this.props.divisionsActions.clearDivisions();
        this.setState(_.extend(this.state, newPouch, {
            step: 1,
            isCheckoutActionsOpen: false,
            isPlayerSelectionOpen: false,
            selectedDivision: null,
            selectedPlan: null,
            questions: null,
            paymentPlans: null,
            divisions: null
        }), function () {
            this.props.pouchActions &&
                this.props.pouchActions.set(newPouch);

            this.props.divisionsActions &&
                this.props.divisionsActions.fetchForRegistrationOfUsers(newPouch.selectedSeason.IdSeason, newPouch.selectedUser.IdUser, newPouch.mode === 1 ? 3 : 4)

            // Scroll to the top !
            //document.getElementById('top-of').scrollIntoView()
        })

    }

    toggleCart = () => {
        this.props.cartActions &&
            this.props.cartActions.close();
    }

    addToCart = () => {

        var { cart } = this.props,
            { questions, selectedDivision, selectedUser, mode } = this.state;

        // 1st validate all the required questions
        if (_.find(questions, (q) => {
            return q.Required && !q.answer;
        })) {
            alert('Please answer all the required questions');
        } else {

            this.setState({
                isCheckoutActionsOpen: true
            }, function () {
                if (!cart)
                    cart = [];

                if (!_.find(cart, (item) => {
                    return (item.selectedUser.IdUser === selectedUser.IdUser &&
                        item.selectedDivision.IdDivision === selectedDivision.IdDivision &&
                        item.mode === mode);
                })) {

                    this.props.cartActions && this.props.cartActions.set([...cart, _.extend({
                        Date: new Date(),
                        Id: generateRandomId(10),
                        questions: _.map(this.state.questions, (q) => {
                            return _.omit(q, 'Answers')
                        })
                    }, _.pick(this.state, 'selectedDivision', 'selectedPlan', 'selectedUser', 'selectedLeague', 'selectedSeason', 'selectedRole', 'selectedTeam', 'mode'))]);
                }
            });
        }
    }

    render() {
        const { fetchingDataLocally, isCheckoutActionsOpen, isPlayerSelectionOpen, selectedPlan, selectedDivision, selectedSeason,
            selectedUser, step, bootstrapped, questions, paymentPlans } = this.state;
        const { fetchingData, league, cart, family, familyRegistration, isCartOpen, pouch } = this.props, { selectedTeam } = pouch;
        return (
            <section>
                {league && <div className="card shadow-box w-100 px-2 py-2 d-flex flex-row" onClick={this.back}>
                    <i className="fa fa-arrow-left align-self-center" />
                    <span className="align-self-center ml-2">Back</span>
                </div>}

                <section className="w3-container">
                    <div className="w3-content">

                        <div className="tile card shadow-box d-flex flex-column mx-auto mt-4" style={{ maxWidth: 600 }}>
                            <Season season={selectedSeason} />
                            <Team selectedTeam={selectedTeam} />
                            <Person selectedUser={selectedUser} selectedRole={{ Name: 'Player ' }} />
                            {selectedDivision && <Division selectedDivision={selectedDivision} />}
                        </div>

                        { /* Payment Plans */}
                        {step === 2 && bootstrapped && selectedDivision && (
                            <section key="step2" style={{ maxWidth: 600 }} className="m-auto d-flex flex-column">
                                <span className="font-18 toBold black mt-2">Select your Payment Plan</span>
                                <PaymentPlansList paymentPlans={paymentPlans} fnSelect={this.selectPaymentPlan} />
                            </section>)}

                        { /* Questions */}
                        {step === 3 && bootstrapped && (
                            <section key="step3" style={{ maxWidth: 600 }} className="m-auto d-flex flex-column">
                                <span className="font-18 toBold black mt-2">Please answer some questions</span>
                                {questions && questions.map((q, i) => (
                                    <figure className="card tile shadow-box w-100 mt-2 mb-2 ml-auto mr-auto" key={i} style={{ maxWidth: 600 }}>
                                        {q.IdQuestionType === 5 && <SelectQuestion question={q} />}
                                        {q.IdQuestionType === 6 && <RadioQuestion question={q} />}
                                        {q.IdQuestionType === 2 && <TextQuestion question={q} />}
                                        {q.IdQuestionType === 3 && <CheckQuestion question={q} />}
                                        {q.IdQuestionType === 4 && <CheckListQuestion question={q} />}
                                    </figure>))}
                            </section>)}
                    </div>
                    <div style={{ height: 200 }} />
                </section>



                { /* Loader */}
                {bootstrapped && (fetchingData || fetchingDataLocally) && (
                    <div className="d-flex justify-content-center centered-message" key="laoder">
                        <h1 className="white align-self-center block text-center"><i className="fa fa-spin fa-cog" /></h1> </div>)}
                { /* Checkout actions */}
                {isCheckoutActionsOpen && league && <CheckoutActionsPopup router={this.props.router} hfo={true}
                    league={league} isOpen={isCheckoutActionsOpen} toggle={this.toggleCheckoutActions}
                    fnRegisterAnother={this.tooglePlayerSelection} fnOk={this.toggleCheckoutActions} label="Player"
                />}

                { /* Register Another */}

                {isPlayerSelectionOpen && <PersonSelection close={this.togglePlayerSelection} cart={cart}
                    league={league} season={selectedSeason} family={family} fnAddFamilyMember={() => { }}
                    fnOk={this.restart}
                    familyRegistration={familyRegistration} />}

                {isPlayerSelectionOpen && false && <RegistrationPlayerSelection cart={cart} league={league}
                    season={selectedSeason} family={family} isOpen={isPlayerSelectionOpen}
                    toggle={this.cancelRegisterAnother} fnOk={this.restart} familyRegistration={familyRegistration} />}

                {isCartOpen && <CartPopup {...this.props} toggle={this.toggleCart} fnOk={this.toggleCart} isOpen={this.props.isCartOpen} />}


                {((step === 1 && selectedDivision) || (step === 2 && selectedPlan)) && (
                    <button className="btn btn-success btn-lg margin-top" style={{ position: 'fixed', bottom: '1em', right: '1em', borderRadius: 30 }} onClick={this.next}>
                        Next
                        {' '}<i className="fa fa-arrow-right" /></button>)}
                {step === 3 && <button className="btn btn-success btn-lg margin-top" style={{ position: 'fixed', bottom: '1em', right: '1em' }} onClick={this.addToCart}><i className="fa fa-plus" />
                    {' '}Add to Cart</button>}
            </section>
        );
    }
}

export default PendingRegistration;
